import { ColoredDot } from './ColoredDot';

export default ColoredDot;
